var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.985 12.59a.6.6 0 0 0-.19-.348.61.61 0 0 0-.652-.133c-.113.043-.255.185-3.8 3.838a655 655 0 0 1-3.696 3.794c-.008 0-.018-3.887-.02-8.638l-.006-8.638-.046-.09c-.145-.28-.414-.42-.693-.362a.64.64 0 0 0-.459.363l-.046.089-.005 8.638c-.003 4.75-.012 8.638-.02 8.638s-1.672-1.708-3.697-3.794c-3.585-3.693-3.685-3.795-3.804-3.84a.63.63 0 0 0-.842.5.75.75 0 0 0 .048.398c.043.097 8.502 8.836 8.626 8.912a.67.67 0 0 0 .612.017c.072-.037 8.513-8.726 8.596-8.85a.63.63 0 0 0 .094-.493",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDown;